<p-dialog [(visible)]="display" header="Últimas Versiones" [modal]="true" styleClass="p-fluid sm:w-10 lg:w-6 md:w-9"
  (onHide)=hideDialog()>
  @if (loading) {
    <div class="progress-spinner">
      <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
    </div>
  }
  @if (!loading && versions) {
    <div>
      @for (item of versions; track item) {
        <div>
          <div class="card">
            <div class="grid p-fluid">
              <div class="col flex align-items-start flex-wrap">
                <div class="version text-lg w-auto ml-2">V {{item.name}}</div>
                <div class="date text-lg w-auto ml-2">{{item.date | date: 'dd/MM/yyyy'}}</div>
              </div>
            </div>
            @for (change of item.changes; track change) {
              <ul class="sections">
                <li class="change text-sm w-auto ml-2">{{change.description}} <span
                [class]="'course-badge type-' + getType(change.type)">{{getType(change.type)}}</span>
              </li>
            </ul>
          }
        </div>
      </div>
    }
  </div>
}
@if (empty) {
  <div class="card">
    <span colspan="8">No hay versiones disponibles.</span>
  </div>
}
</p-dialog>